import { render, staticRenderFns } from "./FormCreate.vue?vue&type=template&id=2845f71c&scoped=true"
import script from "./FormCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./FormCreate.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormCreate.vue?vue&type=style&index=0&id=2845f71c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2845f71c",
  null
  
)

export default component.exports